import { Injectable } from "@angular/core";
import { APIService, GetLastVRViewQuery, ListVRViewsQuery } from "./graphql.service";
import { Amplify } from 'aws-amplify';
import config from '../../aws-exports'
import { map } from "rxjs";

Amplify.configure(config)

@Injectable({
    providedIn: 'root'
})
export class ConnectionService {


    constructor(private api: APIService) {
    }

    createVRView(viewID: string, setID = null) {
        const date = new Date().toISOString();
        const promise = this.api.CreateVRView({viewID, setID, date, category: 'View'})
        return promise;
    }

    subscribeVRView () {
        return this.api.OnCreateVRViewListener().pipe(map( (response: any) => response.data.onCreateVRView))
    }

    listVRViews(): Promise<ListVRViewsQuery> {
        return this.api.ListVRViews()
    }

    getLastVRView(): Promise<GetLastVRViewQuery>{
        return this.api.GetLastVRView()
    }
  
}